<template>
    <div>
        <a-modal v-model="visible" :title="$t('pdf')" :maskClosable="false" :okText="$t('print')"
            :cancelText="$t('cancel')" :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
            :confirmLoading="waiting" :footer="null" :zIndex="2000" :width="'100vw'"
            :bodyStyle="{ height: '100vh', padding: 0 }" wrapClassName="fullscreen-modal" @cancel="onCancel">
            <div id="container">
                <i class="fa fa-spinner spin fa-2x text-white" v-if="printing"></i>
                <iframe v-if="!printing" :src="src"></iframe>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    name: 'pdfPreview',
    props: {
        value: { type: Boolean, default: false }, // v-model
    }, data() {
        return {
            show: false,
            waiting: false,
            printing: false,
            src: ''
        }
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        ...mapActions('infoInquiry', ['previewPdf']),

        onCancel() {
            this.src = ''
            this.$emit('cancel', false)
        },
        previewPDF() {
            this.printing = true
            this.$store
                .dispatch('infoInquiry/previewPDF')
                .then(response => {
                    this.$toasted.success(response.message)
                    this.printing = false
                    this.src = response.url
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.printing = false
                })
        }
    }
}
</script>

<style scoped>
#container {
    width: 100%;
    height: 100%;
    background: black;
    text-align: center;
}

#container iframe {
    width: 100%;
    height: 100%;
    border: none;
}

#container i {
    margin-top: 40vh;
}

/* make modal fullscreen */
::v-deep(.fullscreen-modal .ant-modal) {
    top: 0 !important;
    padding: 0;
    max-width: 100%;
    height: 100%;
}

::v-deep(.fullscreen-modal .ant-modal-content) {
    height: 100%;
    border-radius: 0;
}
</style>